import * as React from "react";
import dayjs from "dayjs";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const ResponsiveDatePicker = (props) => {
  const { value, onValueChange, label, disablePast } = props;
  
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack spacing={3}>
        <DatePicker
          disablePast={disablePast}
          label={label || "Choose date"}
          openTo="day"
          views={["year", "month", "day"]}
          value={value}
          onChange={(newValue) => {
            onValueChange(newValue);
          }}
          renderInput={(params) => <TextField id="date" required {...params} />}
        />
      </Stack>
    </LocalizationProvider>
  );
};

export default ResponsiveDatePicker;
